import * as React from 'react';
import { forwardRef } from 'react';
import classNames from 'classnames';
import ListItemCaption from './caption';
import ListItemExtra from './extra';
import ItemContent from './content';
import { CnListItemAction, CnListItemMedia } from './media';
import ItemTitle from './title';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import { CnIcon } from '@/components/cn-icon';
const arrowIconMap = {
    right: 'arrow-right',
    up: 'arrow-up',
    down: 'arrow-down',
    loading: 'loading',
};
const renderExtra = (ext) => {
    if (isString(ext)) {
        return React.createElement(ListItemExtra, null, ext);
    }
    else if (ext) {
        return ext;
    }
    return null;
};
const CnListItem = (props, ref) => {
    const { children, prefix = 'cn-ui-m-', arrow, media, title, subTitle, description, extra, className, onClick, disabled = false, ...others } = props;
    return (React.createElement("div", { ...others, className: classNames(`${prefix}list-item`, {
            [`${prefix}list-item--clickable`]: isFunction(onClick),
            [`${prefix}list-item--disabled`]: disabled,
        }, className), ref: ref, onClick: (...args) => {
            if (!disabled && onClick) {
                onClick(...args);
            }
        } },
        React.createElement("div", { className: `${prefix}list-item-inner` },
            media ? React.createElement(CnListItemMedia, null, media) : null,
            React.createElement("div", { className: `${prefix}list-item-container` },
                title || description ? (React.createElement(ItemContent, null,
                    title ? React.createElement(ItemTitle, null, title) : null,
                    subTitle ? React.createElement(ListItemCaption, null, subTitle) : null,
                    description ? (React.createElement(ListItemCaption, null, description)) : null)) : null,
                extra || isString(arrow) ? (React.createElement(CnListItemAction, null,
                    renderExtra(extra),
                    isString(arrow) ? (React.createElement(CnIcon, { size: "xs", className: `${prefix}list-item-icon`, type: arrowIconMap[arrow] })) : null)) : null,
                children))));
};
CnListItem.displayName = 'CnListItem';
export default forwardRef(CnListItem);
